import Keycloak from 'keycloak-js';

const url = import.meta.env.VITE_KEYCLOAK_URL;
const realm = import.meta.env.VITE_KEYCLOAK_REALM;
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT;

export const ssoEnabled = !!url;

const redirectUri = () => window.location.origin + '/login';
let kc = null;
let initPromise = null;

// keycloak-js đọc code/state trên URL (nếu có) và đổi lấy token với PKCE S256.
function init() {
    if (!initPromise) {
        kc = new Keycloak({ url, realm, clientId });
        initPromise = kc.init({ pkceMethod: 'S256', checkLoginIframe: false, responseMode: 'query', redirectUri: redirectUri() });
        // Init lỗi thì cho phép thử lại, không giữ promise bị reject.
        initPromise.catch(() => { initPromise = null; });
    }
    return initPromise;
}

export async function ssoLogin() {
    await init();
    await kc.login({ redirectUri: redirectUri() });
}

export async function ssoHandleCallback() {
    if (!ssoEnabled) return null;
    const p = new URLSearchParams(window.location.search);
    if (p.has('error')) {
        // Người dùng huỷ / Keycloak từ chối (vd. access_denied): bỏ query và báo lỗi.
        window.history.replaceState({}, document.title, window.location.pathname);
        throw new Error('SSO callback error: ' + p.get('error'));
    }
    if (!p.has('code') || !p.has('state')) return null;
    try {
        // Ném lỗi (init lỗi hoặc không xác thực được) để Login.vue báo cho người dùng.
        if (!(await init())) throw new Error('SSO callback not authenticated');
        return { accessToken: kc.token, idToken: kc.idToken };
    } finally {
        // Xoá code/state khỏi thanh địa chỉ ở mọi nhánh để không dùng lại khi reload.
        window.history.replaceState({}, document.title, window.location.pathname);
    }
}

export function ssoLogoutUrl(idToken) {
    const q = new URLSearchParams({ client_id: clientId, post_logout_redirect_uri: redirectUri(), id_token_hint: idToken });
    return `${url}/realms/${realm}/protocol/openid-connect/logout?${q}`;
}
